import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"#f5eccd"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sancus_air_table_form = _resolveComponent("sancus-air-table-form")!
  const _component_sancus_navbar = _resolveComponent("sancus-navbar")!
  const _component_sancus_hero_header = _resolveComponent("sancus-hero-header")!
  const _component_sancus_air_table = _resolveComponent("sancus-air-table")!
  const _component_sancus_info_section = _resolveComponent("sancus-info-section")!
  const _component_sancus_footer = _resolveComponent("sancus-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_sancus_air_table_form, {
      onCloseForm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAddDataForm($event)))
    }, null, 512), [
      [_vShow, !this.dataFormHidden]
    ]),
    _createVNode(_component_sancus_navbar),
    _createVNode(_component_sancus_hero_header),
    _createVNode(_component_sancus_air_table, {
      class: "pb-8",
      onAddDataClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleAddDataForm($event)))
    }),
    _createVNode(_component_sancus_info_section, { class: "pb-8" }),
    _createVNode(_component_sancus_footer)
  ]))
}